{
    "component-card-search-list.empty-state.title.non-final": "<strong>Koppel deze repository aan een softwarecomponent</strong>",
    "component-card.add-chat-channel": "Chatkanaal toevoegen",
    "component-card.chat-channels": "Chatkanalen",
    "component-card.expander.show-more-link": "Nog {formattedCount} tonen"
}
